package kz.dentalcrm.app.screens.service_categories.add.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface AddServiceCategoryViewEvent : ViewEvent {
    data class AddCategory(val name: String) : AddServiceCategoryViewEvent
    data object Reset : AddServiceCategoryViewEvent
}
